import {Component, Optional, ViewEncapsulation, AfterViewInit, PipeTransform, Pipe} from '@angular/core';
import {TranslateService} from 'ng2-translate/ng2-translate';
import {MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar} from '@angular/material';
import { LoadingBarService } from '@ngx-loading-bar/core';
import {SharedDataService} from 'app/shared-data.service'
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  	selector: 'chankya-app',
  	template: '<ngx-loading-bar [height]="5" [color]="\'#ffcc00\'" ></ngx-loading-bar> <router-outlet></router-outlet>',
    encapsulation: ViewEncapsulation.None
})

export class ChankyaAppComponent {
  constructor(translate: TranslateService, private loadingBar: LoadingBarService) {
       translate.addLangs(['en', 'fr']);
       translate.setDefaultLang('en');

       const browserLang: string = translate.getBrowserLang();
       translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
     }


  startLoading() {
    this.loadingBar.start();
  }

  stopLoading() {
    this.loadingBar.complete();
  }



}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/app.component.ts